import classNames from 'classnames'
import styles from './styles.module.scss'

type BackgroundStyles = {
  primary: string
  secondary?: string | null
  image?: string | null
}

export type SwatchColorProps = BackgroundStyles & {
  colorName: string
  active: boolean
  isUnavailable?: boolean
  size?: 'small' | 'medium'
}

function getBackgroundStyles({ primary, secondary, image }: BackgroundStyles) {
  if (image) {
    return {
      '--swatch-background-image': `url("${image}")`,
      '--swatch-background-color': primary
    }
  }

  if (secondary) {
    return {
      '--swatch-background-image': `linear-gradient(135deg, ${primary} 50%, ${secondary} 50%)`
    }
  }

  return {
    '--swatch-background-color': primary
  }
}

const SwatchColor = ({
  colorName,
  image,
  primary,
  secondary,
  active,
  size = 'medium',
  isUnavailable
}: SwatchColorProps) => {
  const classes = classNames(styles.SwatchColor, {
    [styles.SwatchColor_selected]: active,
    [styles.size_small]: size === 'small',
    [styles.isUnavailable]: isUnavailable,
    [styles.SwatchColor_plain]: colorName?.toLowerCase() === 'white'
  })

  const backgroundStyles = getBackgroundStyles({
    primary,
    secondary,
    image
  }) as React.CSSProperties

  return (
    <div style={backgroundStyles} className={classes} aria-label={colorName}>
      <span aria-hidden>{colorName}</span>
    </div>
  )
}

export default SwatchColor
